// Funções simples para ofuscar o ID no banco de dados
export const ocultar = (text: string) => btoa(text); // Transforma em Base64
export const revelar = (text: string) => atob(text);  // Decodifica o Base64